'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dView$002dGroup$002dView from "./presto.-View-Group-View.js";
var $p;
/** @constructor */
function $c_Lpresto_GroupsView$$anon$32(group$35) {
  this.a85 = null;
  this.a85 = group$35;
}
export { $c_Lpresto_GroupsView$$anon$32 as $c_Lpresto_GroupsView$$anon$32 };
$p = $c_Lpresto_GroupsView$$anon$32.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_GroupsView$$anon$32;
/** @constructor */
function $h_Lpresto_GroupsView$$anon$32() {
}
export { $h_Lpresto_GroupsView$$anon$32 as $h_Lpresto_GroupsView$$anon$32 };
$h_Lpresto_GroupsView$$anon$32.prototype = $p;
$p.bf = (function() {
  return ("Grupo " + this.a85.ja);
});
$p.c9 = (function() {
  return new $j_presto$002e$002dView$002dGroup$002dView.$c_Lpresto_ViewGroupView(this.a85);
});
$p.c8 = (function(req) {
  throw new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_ClassCastException();
});
var $d_Lpresto_GroupsView$$anon$32 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_GroupsView$$anon$32, "presto.GroupsView$$anon$32", ({
  Kj: 1,
  O: 1
}));
export { $d_Lpresto_GroupsView$$anon$32 as $d_Lpresto_GroupsView$$anon$32 };
//# sourceMappingURL=presto.-Groups-View$$anon$32.js.map
